export default "__VITE_ASSET__e363d5aa__"